import {
  grant_type,
  client_id,
  client_secret,
  username,
  password
} from "../Utils/Constants";
import { getToken, signUp, logIn } from "../apis/Auth";

export const doSMS = async (phoneNumber, pin) => {
  try {
    let response = await fetch(
      `https://apricot-mole-2227.twil.io/phone_SMS?phoneNumber=${phoneNumber}&pin=${pin}`,
      {
        method: "GET"
      }
    );
    let res = await response.json();
    return res;
  } catch (err) {
    return err;
  }
};
export const clearZero = function(str) {
  if (str.charAt(0) === "0") str = str.replace("0", "");
  return str;
};
export function isDateValidate(date) {
  if (
    date &&
    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(
      date
    )
  )
    return true;
  else return false;
}

export const register = async profile => {
  try {
    console.log("profile", profile);
    const {
      firstname,
      lastname,
      email,
      key,
      postcode,
      number,
      street,
      city,
      phonenumber,
      dob,
      avatar
    } = profile;
    let response = await getToken(
      grant_type,
      client_id,
      client_secret,
      username,
      password
    );
    let access_token = response.access_token;
    console.log("access_token", access_token);
    return signUp(
      firstname,
      lastname,
      email,
      key,
      postcode,
      number,
      street,
      city,
      phonenumber,
      dob,
      avatar,
      access_token
    );
  } catch (err) {
    console.log("error_function", err);
    return err;
  }
};
export const getAddresses = async postcode => {
  try {
    let response = await fetch(
      `https://api.getAddress.io/find/${postcode}?api-key=mlIpZc2yjUS3o0J7Nuuvsg18916`,
      {
        method: "GET"
      }
    );
    let res = await response.json();
    return res;
  } catch (err) {
    return err;
  }
};



// WEBPACK FOOTER //
// ./src/functions/Auth.js